module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0116-3d39b1b7f46b9e7df4551e127de401fe.png";